var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCookie = function SvgCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 7.51a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M6.375 11.26a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25M11.25 12.01a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.462 8.252c-1.342-.023-2.775-1.463-2.01-3.165-2.227.75-4.335-1.193-3.892-3.42C5.332.564 1.5 4.817 1.5 9.009c0 4.14 3.36 7.5 7.5 7.5 4.417 0 7.905-3.81 7.462-8.257M9 15.009c-3.308 0-6-2.692-6-6 0-2.482 2.047-6.135 6.06-6.015.315 1.905 1.83 3.42 3.742 3.705a3.79 3.79 0 0 0 2.19 2.723c-.217 3.232-2.947 5.587-5.992 5.587"
  })));
};
export default SvgCookie;